define(function(require) {
    'use strict';

    const DropDownView = require('common/dropdown.editable/dropdown.editable.view');
    const core = require('core');
    const _ = require('underscore');

    return DropDownView.extend({

        events: {
            'tap .fn-select-dropdown': 'changeValue'
        },

        changeValue: function(e) {
            const selectedValue = e.target.getAttribute('value');
            this.options.form.isChangedData = true;
            this.$value.val(selectedValue);

            if (selectedValue === this.options.unlimitedUmount) {
                this.$input.val(e.target.innerHTML);
            } else {
                const valueWIthCurrency = e.target.dataset.currencySymbol + ' ' + e.target.innerHTML;
                this.$input.val(valueWIthCurrency);
            }

           core.trigger('loss:validation');
        },

        getRenderOptions: function() {
            const isRegister = this.options.form.el.className.includes('form_name_registration');
            const unlimited = this.options.form.options?.data?.lossLimitsConfig?.unlimitedAmount;

            return _.extend({}, this.options, {
                inputTextValue: this.getDisplayValue(this.model.get('value')),
                isRegister,
                unlimited
            });
        },

        render: function() {
            this.$el.html(this.tmpl(this.options.template, this.getRenderOptions()));
            this.$value = this.$('.fn-input-hidden');
            this.$input = this.$('.fn-input-text');
            this.$select = this.$('.fn-select');

            return this;
        }
    });
});
